__turbopack_context__.v({
  "affiliationsBlock": "RichText-module__ALRbUa__affiliationsBlock",
  "authorsBlock": "RichText-module__ALRbUa__authorsBlock",
  "referenceList": "RichText-module__ALRbUa__referenceList",
  "richText": "RichText-module__ALRbUa__richText",
  "w-richtext-align-center": "RichText-module__ALRbUa__w-richtext-align-center",
  "w-richtext-align-floatleft": "RichText-module__ALRbUa__w-richtext-align-floatleft",
  "w-richtext-align-floatright": "RichText-module__ALRbUa__w-richtext-align-floatright",
  "w-richtext-align-fullwidth": "RichText-module__ALRbUa__w-richtext-align-fullwidth",
  "w-richtext-align-normal": "RichText-module__ALRbUa__w-richtext-align-normal",
});
